<template>
    <BasicTile :width="240" class="background-tile-secondary w-100 rounded-md-24 rounded-16 elevation-10">
        <v-icon class="w-100 text-subtitle-2 text-lg-subtitle-1 mt-4">
            <slot name="icon"></slot>
        </v-icon>
        <div align="center"
            class="mt-6 mt-md-8 mb-1 mb-md-2">
            <slot name="title"></slot>
        </div>
        <div align="center" :style="{ opacity: 0.6 }">
            <slot name="subtitle"></slot>
        </div>
    </BasicTile>
</template>



<script>



import BasicTile from "@/components/Tiles/Basic-Tile.vue";


export default {
    name: 'StatsTile',
    components: {
        BasicTile,
    }
}
</script>
